import { jsx } from "react/jsx-runtime";
import { Text } from "braid-design-system";
import classNames from "classnames";
import { useEmployerHeaderContext } from "../../../EmployerFooter/EmployerFooter.mjs";
import { item } from "./AccountNavigation.css.mjs";
import { headerLink, navItem, desktopNavItem, desktopNavItemLight, mobileNavMedium, nestedMobileNavItem, navFontWeightMedium } from "./Navigation.css.mjs";
const handleClick = (props, analyticsEvent, handleInteractionTracking) => (event) => {
  if (analyticsEvent) {
    handleInteractionTracking(analyticsEvent);
  }
  if (props.onClick) {
    props.onClick(event);
  }
};
const CustomHeaderDesktopLink = ({
  active = false,
  activeStyle,
  linkRenderer: LinkRenderer,
  analyticsEvent,
  ...props
}) => {
  const headerItemLinkClasses = [
    headerLink,
    navItem,
    desktopNavItem,
    active ? activeStyle : "",
    desktopNavItemLight
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = { ...props, className: classNames(headerItemLinkClasses) };
  return /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking)
    }
  ) });
};
const CustomHeaderMobileLink = ({
  active = false,
  activeStyle,
  linkRenderer: LinkRenderer,
  isNested = false,
  analyticsEvent,
  ...props
}) => {
  const headerItemLinkClasses = [
    headerLink,
    navItem,
    mobileNavMedium,
    active ? activeStyle : "",
    isNested ? nestedMobileNavItem : ""
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    className: classNames(headerItemLinkClasses)
  };
  return /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking)
    }
  ) });
};
const CustomDesktopDropdownLink = ({
  linkRenderer: LinkRenderer,
  analyticsEvent,
  ...props
}) => {
  const desktopDropdownLinkClasses = [
    headerLink,
    navItem,
    item,
    navFontWeightMedium
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    className: classNames(desktopDropdownLinkClasses)
  };
  return /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking)
    }
  ) });
};
const CustomDesktopSubItemHeaderLink = ({
  children,
  active,
  activeStyle,
  linkRenderer: LinkRenderer,
  analyticsEvent,
  ...props
}) => {
  const sharedHeaderSubItemLinkClasses = [
    headerLink,
    navItem,
    desktopNavItem,
    active ? activeStyle : ""
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    className: classNames(sharedHeaderSubItemLinkClasses),
    children
  };
  return /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking)
    }
  ) });
};
export {
  CustomDesktopDropdownLink,
  CustomDesktopSubItemHeaderLink,
  CustomHeaderDesktopLink,
  CustomHeaderMobileLink
};
